export const messages = {
    "wre-dashboard.nav-menu.item.shared": "Compartilhamento",
    "wre-dashboard.nav-menu.item.backups": "Backups",
    "wre-dashboard.nav-menu.item.machines": "Máquinas",
    "wre-dashboard.nav-menu.item.account": "Conta",
    "wre-dashboard.search.input.hint": "Pesquisa",
    "wre-dashboard.search.label.breadcrumb": "Resultados da busca",
    "wre-dashboard.search.message.empty": "Nenhum item corresponde à sua pesquisa",
    "wre-dashboard.side-bar.selected.title:plural": "{count} itens selecionados | {count} item selecionado | {count} itens selecionados",
    "wre-dashboard.side-bar.backup-type.disk": "Disco",
    "wre-dashboard.side-bar.backup-type.file": "Arquivo",
    "wre-dashboard.side-bar.backup-type.notarized": "Arquivos e pastas notarizadas",
    "wre-dashboard.side-bar.backup-type.exchange": "Aplicativo – Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "Aplicativo – Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "Aplicativo – Estado do sistema",
    "wre-dashboard.side-bar.backup-type.application": "Aplicativo",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} restantes",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} usado",
    "wre-dashboard.space-indicator.label.unlimited": "Ilimitado",
    "wre-dashboard.backups-table.column.name": "Nome",
    "wre-dashboard.backups-table.column.size": "Tamanho",
    "wre-dashboard.backups-table.column.version": "Último backup",
    "wre-dashboard.backups-table.message.no-backups": "Ainda não há backups na nuvem",
    "wre-dashboard.backups-sidebar.label.size": "Tamanho",
    "wre-dashboard.backups-sidebar.label.type": "Tipo",
    "wre-dashboard.backups-sidebar.label.version": "Última versão",
    "wre-dashboard.backups-sidebar.label.created": "Criado em:",
    "wre-dashboard.backups-sidebar.label.machine": "Máquina",
    "wre-dashboard.backups-sidebar.label.owner": "Proprietário",
    "wre-dashboard.content-table.column.name": "Nome",
    "wre-dashboard.content-table.column.versions": "Versões",
    "wre-dashboard.content-table.column.volumes": "Volumes",
    "wre-dashboard.content-table.column.path": "Caminho",
    "wre-dashboard.content-table.column.size": "Tamanho",
    "wre-dashboard.content-table.column.version": "Última versão",
    "wre-dashboard.content-table.action.versions": "Versões",
    "wre-dashboard.content-table.action.restore": "Baixar",
    "wre-dashboard.content-table.action.share": "Compartilhar link",
    "wre-dashboard.content-table.label.size": "Tamanho",
    "wre-dashboard.content-table.label.created": "Criado em:",
    "wre-dashboard.content-table.label.modified": "Modificado",
    "wre-dashboard.content-table.message.empty-folder": "Esta pasta está vazia",
    "wre-dashboard.password-dialog-box.title.backup": "Backup criptografado",
    "wre-dashboard.password-dialog-box.title.archive": "Arquivo criptografado",
    "wre-dashboard.password-dialog-box.message.backup": "Especifique a senha para acessar o backup {displayName}",
    "wre-dashboard.password-dialog-box.message.archive": "Especifique a senha para acessar o arquivo {displayName}",
    "wre-dashboard.password-dialog-box.hint.password": "Senha",
    "wre-dashboard.password-dialog-box.message.invalid-password": "A senha está incorreta",
    "wre-dashboard.form.button.open": "Abrir",
    "wre-dashboard.form.button.close": "Fechar",
    "wre-dashboard.form.button.cancel": "Cancelar",
    "wre-dashboard.form.button.delete": "Excluir",
    "wre-dashboard.shared-content-table.column.name": "Nome",
    "wre-dashboard.shared-content-table.column.location": "Local",
    "wre-dashboard.shared-content-table.column.source": "Fonte",
    "wre-dashboard.shared-content-table.column.days": "Dias",
    "wre-dashboard.shared-content-table.column.downloads": "Downloads",
    "wre-dashboard.shared-content-table.column.shared": "Compartilhado em",
    "wre-dashboard.shared-content-table.label.shared": "Compartilhado em",
    "wre-dashboard.shared-content-table.label.backup": "Fonte",
    "wre-dashboard.shared-content-table.action.share": "Compartilhar link",
    "wre-dashboard.shared-content-table.action.settings": "Configurações do link",
    "wre-dashboard.shared-content-table.action.delete": "Excluir link",
    "wre-dashboard.shared-content-table.action.delete-selected": "Excluir links",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} livre de {totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: Espaço ilimitado",
    "wre-dashboard.account-page.button.sign-out": "Sair",
    "wre-dashboard.account-page.button.manage-subscription": "Gerenciar licença",
    "wre-dashboard.account-page.message.subscription.active": "Sua licença para {brandName} de espaço expira em",
    "wre-dashboard.account-page.message.subscription.trial": "A avaliação de {brandName} está ativa até",
    "wre-dashboard.account-page.message.subscription.expired": "Sua licença para {brandName} de espaço expirou em",
    "wre-dashboard.account-page.message.worm-status.storage-full": "Seu armazenamento no {brandName} está cheio. Você não pode executar backup ou arquivar dados na nuvem.",
    "wre-dashboard.account-page.message.worm-status.less-than": "Menos que {percent} porcento está livre. Não será possível utilizar {brandName} em breve.",
    "wre-dashboard.versions-dialog-box.title": "Versões de {fileName}",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "Copiar link",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "Configurações do link",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "Qualquer pessoa com o link pode visualizar a última versão dos dados",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "Compartilhado em {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "Link copiado",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "Erro na cópia do link",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "Excluir link",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "Este link não funcionará mais para quem o tiver",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "Excluir links",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "Estes links não funcionarão mais para quem os tiver",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "Configurações do link",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "Excluir link",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "Feito",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "Senha",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "Redefinir senha",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "Proteção por senha",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "Proteja o link com uma senha",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "Expiração",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "Limite de downloads",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "Desativar este link em {splitMarker} dias | Desativar este link em {splitMarker} dia | Desativar este link em {splitMarker} dias",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "Desativar este link depois de {splitMarker} downloads | Desativar este link depois de {splitMarker} download | Desativar este link depois de {splitMarker} downloads",
    "wre-dashboard.sub-accounts-dialog-box.title": "Contas",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "Pesquisa",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "Nenhum item corresponde à sua pesquisa",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "Nome",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "Utilização",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "Último backup",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "Expiração",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} livre de {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "Assinatura por Volume",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "Expirado",
    "wre-dashboard.machines-table.column.name": "Nome",
    "wre-dashboard.machines-table.column.size": "Tamanho",
    "wre-dashboard.machines-table.message.no-machines": "Ainda não há máquinas na Nuvem"
};
